module.exports = __webpack_public_path__ + "static/media/Harrison Nnaji.bb32e163.jpeg";